class MonthService {
  list() { //eslint-disable-line
    return [{
      key: 'January',
      value: 1
    }, {
      key: 'February',
      value: 2
    }, {
      key: 'March',
      value: 3
    }, {
      key: 'April',
      value: 4
    }, {
      key: 'May',
      value: 5
    }, {
      key: 'June',
      value: 6
    }, {
      key: 'July',
      value: 7
    }, {
      key: 'August',
      value: 8
    }, {
      key: 'September',
      value: 9
    }, {
      key: 'October',
      value: 10
    }, {
      key: 'November',
      value: 11
    }, {
      key: 'December',
      value: 12
    }];
  }
}

export default MonthService;



// WEBPACK FOOTER //
// ./src/services/monthService.js